import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { createGatewaysSyncActions } from './gateways.actions'
import { gatewaysInitialState } from './gateways.slice'
import type { GatewaysStore } from './gateways.type'

export const useGatewaysStore = create<GatewaysStore>()(
  devtools(
    subscribeWithSelector(
      immer((set) => ({
        ...gatewaysInitialState,
        ...createGatewaysSyncActions(set),
      }))
    ),
    {
      name: StoreDevtoolsName.Gateways,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
